import { useTranslation } from 'react-i18next'

import { Badge, BadgeVariant } from '@percent/lemonade'

export function ProgramStatusBadge({ status }: { status: 'on' | 'off' }) {
  const { t } = useTranslation()
  const getStatusVariant = (): BadgeVariant => {
    if (status === 'on') return 'positive'

    if (status === 'off') return 'critical'

    return 'default'
  }

  return <Badge variant={getStatusVariant()}>{t(`typography.${status}`)}</Badge>
}
